import React from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import Browser from "ui/common/browser/Browser";
import WindowsController from "./WindowsController";
import Customize from "ui/common/customize/Customize";
import Recent from "ui/common/recent/Recent";
import Logger from "ui/common/logger/Logger";
import Column from "../components/Column";

class DesktopChat extends React.Component {

	render() {
		return(
			<React.Fragment>
				{this.props.configuration.debug &&
					<div className="wcColumn">
						<Logger/>
					</div>
				}
				<WindowsController />
				{ this.props.configuration.interface.browser.enabled &&
					<Column
						id="browser"
						title={ this.props.i18nBase.usersAndChannels }
						className="wcBrowserColumn"
						contentClassName="wcBrowserContent"
						headerElement={ <Recent /> }
						minimizable={ this.props.configuration.interface.chat.fb.browserMinimizable }
					>
						<Browser keepInside=".wcSidebar" infoWindowPosition={ this.props.configuration.interface.chat.fb.location === 'left'  ? 'right center' : 'left center' }/>
						<Customize />
					</Column>
				}
			</React.Fragment>
		)
	}

}

DesktopChat.propTypes = {
	configuration: PropTypes.object.isRequired
};

export default connect(
	(state) => ({
		configuration: state.configuration,
		i18nBase: state.configuration.i18n
	})
)(DesktopChat);